/**
 * 指标卡片列表容器组件
 * 文档: src/pages/opinion/specs/003-ads-overview/components/MetricCard/index.md
 */
import React, { useMemo } from 'react';
import { Row, Col } from 'tea-component';
import { history } from 'umi';
import MetricCard from './MetricCard';
import { useAdStatsData } from '../../hooks/useAdStatsData';
import {
  adsActiveAdsTips,
  adsActiveCreativesTips,
  adsNewCreativesTips,
} from '@op/components/BubbleCommon';
import { getCardMetricLabel } from '../../utils/metricLabels';
import './index.scss';

interface IMetricCardListProps {
  gameInfo?: any;
  filter?: any;
  isSupportAdCreative?: boolean;
}

// 卡片基础配置（title 为基础 key，动态标题由 filter 决定）
const CARD_BASE_CONFIG = [
  {
    baseTitle: 'Active Ads',
    type: 'all_creative' as const,
    dataKey: 'allCreative' as const,
    clickType: 'creative',
    tipsMap: adsActiveAdsTips,
  },
  {
    baseTitle: 'Active Creatives',
    type: 'all_material' as const,
    dataKey: 'allMaterial' as const,
    clickType: 'material',
    tipsMap: adsActiveCreativesTips,
  },
  {
    baseTitle: 'New Creatives',
    type: 'new_material' as const,
    dataKey: 'newMaterial' as const,
    clickType: 'newMaterial',
    tipsMap: adsNewCreativesTips,
  },
];

const MetricCardList: React.FC<IMetricCardListProps> = ({
  gameInfo,
  filter,
  isSupportAdCreative,
}) => {
  const { cardData, loading, translationMap, hasDataDatetime } = useAdStatsData(
    { filter, gameInfo },
  );


  // 根据 filter 生成动态卡片配置
  const cardConfig = useMemo(
    () =>
      CARD_BASE_CONFIG.map((cfg) => ({
        ...cfg,
        title: getCardMetricLabel(cfg.baseTitle, filter),
      })),
    [filter],
  );

  const handleCardClick = (clickType: string) => {
    if (!isSupportAdCreative) return;
    const basePath = '/marketing/CompetitorsAdCreatives';

    const states: any = {
      game_ids: [gameInfo.edition_unified_id],
      ...filter,
      date_type: 'daily' // 跳转marketing写死daily date_type
    };

    switch (clickType) {
      case 'creative':
        history.push({ pathname: basePath, state: states });
        break;
      case 'material':
        history.push({ pathname: basePath, search: 'tab=creatives', state: states });
        break;
      case 'newMaterial':
        history.push({
          pathname: basePath,
          search: 'tab=creatives',
          state: {
            ...states,
            first_seen_end: filter.end_time,
            first_seen_start: filter.start_time,
          },
        });
        break;
    }
  };

  return (
    <div className="dbo-ads-overview__metric-cards">
      <Row gap={16}>
        {cardConfig.map((config) => (
          <Col span={8} key={config.type}>
            <MetricCard
              title={config.title}
              type={config.type}
              filter={filter}
              isSupportAdCreative={isSupportAdCreative}
              data={cardData?.[config.dataKey]}
              translationMap={translationMap}
              loading={loading}
              onClick={() => handleCardClick(config.clickType)}
              hasDataDatetime={hasDataDatetime}
              tipsMap={config.tipsMap}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default React.memo(MetricCardList);
